export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6994.3f79b221.jpg";